import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';
import { Filtros } from './filtros';

@Component({
  selector: 'app-faturamento-recebidos',
  templateUrl: './faturamento-recebidos.component.html',
  styleUrls: ['./faturamento-recebidos.component.scss']
})
export class FaturamentoRecebidosComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  filtros: Filtros = new Filtros();

  lstParticipante: Array<any> = [{}];
  lstUnidades: IdDescricao[];
  lstTipoDR: IdDescricao[] = [];
  // tipoId?: number = null;
  lstTipoProcesso: IdDescricao[] = [];

  lstConta: IdDescricao[] = [];

  rel: any;

  dataRelatorio: Date;

  totalRecebidas = 0;
  pesquisando: boolean = false;
  showTable: boolean = false;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {

    this.filtros.TipoDRId = 0;
    this.filtros.TipoDeAcaoId = 0;
  }

  ngOnInit() {
    this.filtros.ProcessoId = null;
    //this.filtros.TipoData = 'recebimento'; //depreciado
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
    this.consultasService.consultar('CONTA').toPromise().then(data => this.lstConta = data);
    this.consultasService.consultar('DR').toPromise().then(data => this.lstTipoDR = data);
    this.consultasService.consultar('TIPODEACAO').toPromise().then(data => this.lstTipoProcesso = data);


  }
  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.relatorioService.faturamentoRecebidas(this.filtros)
      .toPromise().then((data) => {
        this.rel = data;
        this.somaSaldo();
        this.pesquisando = false;

        if (this.totalRecebidas === 0) {
          this.toastr.info("Busca não encontrou resultados");
          this.showTable = false;
        } else {
          this.showTable = true;
        }

      }, erro => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      });
    //  () => this.pesquisando = false);
  }

  public somaSaldo(): void {
    this.totalRecebidas = 0;
    this.rel.forEach(element => { this.totalRecebidas += element.ValorRecebido; });
    //this.rel.reduce((acc, itemValue) => acc + itemValue.ValorRecebido, 0);
  }

  @ViewChild('relatorioRecebido') relatorioRecebidos: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("relatorioRecebido").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório faturamento recebidos", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Cod. Processo', this.filtros.ProcessoId);

    /* refatorar para remover 3 parâmetros, creio que 2 já bastam */
    parseDateAdicionaMap('Recebimento Inicial','', this.filtros.DataInicial);
    parseDateAdicionaMap('Recebimento Final','', this.filtros.DataFinal);
    
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);
    obtemDescricaoAdicionaMap('Participante', this.lstParticipante, this.filtros.ParticipanteId);
    obtemDescricaoAdicionaMap('Tipo DR', this.lstTipoDR, this.filtros.TipoDRId);
    obtemDescricaoAdicionaMap('Conta', this.lstConta, this.filtros.ContaId);
    obtemDescricaoAdicionaMap('Tipo de Ação', this.lstTipoProcesso, this.filtros.TipoDeAcaoId);

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, inicialFinal: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData + inicialFinal, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }
}
